import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'

export default {
  getAccounts: params => {
    const query = gql`
      query($filter: AccountsFilterInput) {
        allAccounts(filter: $filter) {
          data {
            id
            uid
            nickname
            username
            roles {
              id
              name
              platform
            }
            telegram_id
            potato_id
            enigma_id
            last_login_at
            last_login_ip
            white_list_ip
            status
            creator {
              nickname
            }
            created_at
            type
            customer_service_meta {
              departments {
                id
                name
              }
            }
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  getAccount: params => {
    const query = gql`
      query($id: Int!) {
        account(id: $id) {
          id
          nickname
          username
          roles {
            id
            name
            platform
            menus {
              id
              # name
              code
              action
            }
          }
          white_list_ip
          telegram_id
          potato_id
          enigma_id
          status
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  createAccount: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateAccountInput!) {
        createAccount(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  updatePasswordForOP: (params, opts = {}) => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateAccountPasswordInput!) {
        updatePassword(id: $id, in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },
  updateAccount: params => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateAccountInput!) {
        updateAccount(id: $id, in: $in)
      }
    `
    return graphqlAjax('post', mutation, params)
  }
}
